// import courseService from 'ApiService/Admin/courseService';
// import studentService from 'ApiService/Admin/studentService';
// import batchService from 'ApiService/Admin/batchService';

// import Card from 'components/card';
// import { AuthContext } from 'contexts/AuthContext';
// import { useContext, useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';

// import SelectClass from './Class/Index';
// import AttendancesSheet from './Sheet/Index';
// import ConfirmationModal from 'pages/Common/ConfirmationModal';

// const MarkAttendance = () => {
//   /* ================= STEP ================= */
//   const [currentStep, setCurrentStep] = useState(1);

//   /* ================= CLASS DATA ================= */
//   const [classData, setClassData] = useState({
//     courseId: '',
//     batchStructureId: '',
//     batchId: '',
//   });

//   /* ================= DATA ================= */
//   const [courses, setCourses] = useState([]);
//   const [batchStructures, setBatchStructures] = useState([]);
//   const [attendance, setAttendance] = useState([]);

//   /* ================= UI ================= */
//   const [disable, setDisable] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [loadingCourses, setLoadingCourses] = useState(true);
//   const [selectedStudent, setSelectedStudent] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   /* ================= AUTH ================= */
//  const { state } = useContext(AuthContext);
//   const user = state?.user;
//   const role = user?.role;
//   const isSuperAdmin = role === 'superadmin';

//   const selectedBranch = isSuperAdmin
//     ? state?.selectedBranch
//     : user?.branch?._id;

//   /* ================= HELPERS ================= */
//   const clearAttendance = () => {
//     setAttendance([]);
//   };

//   /* ================= FETCH COURSES ================= */
//   const fetchCourses = async () => {
//     setLoadingCourses(true);
//     try {
//       const res = await courseService.getAllCourses(selectedBranch);
//       setCourses(res?.data?.courses || []);
//     } catch {
//       toast.error('Failed to fetch courses');
//       setCourses([]);
//     } finally {
//       setLoadingCourses(false);
//     }
//   };

//   useEffect(() => {
//     if (!selectedBranch) return;
//     fetchCourses();
//   }, [selectedBranch]);

//   /* ================= FETCH STRUCTURES ================= */
//   const fetchBatchStructures = async (courseId) => {
//     try {
//       const res = await batchService.getBatchStructuresByCourse(
//         courseId,
//         selectedBranch
//       );
//       setBatchStructures(res?.data?.batchStructures || []);
//     } catch {
//       toast.error('Failed to fetch batch structures');
//       setBatchStructures([]);
//     }
//   };

//   /* ================= FETCH BATCHES ================= */
//   const fetchBatchesByStructure = async (structureId) => {
//     try {
//       const res = await batchService.getBatchesByBatchStructure(
//         structureId,
//         selectedBranch
//       );
//       return res?.data?.batches || [];
//     } catch {
//       toast.error('Failed to fetch batches');
//       return [];
//     }
//   };

//   /* ================= FETCH STUDENTS ================= */
//   const getStudents = async () => {
//     try {
//       const res = await studentService.getAllStudentforPlacement(
//         classData.courseId,
//         classData.batchId,
//         selectedBranch
//       );

//       const students = res?.data?.data || [];

//       if (!students.length) {
//         toast.info('No students found');
//         setAttendance([]);
//         return;
//       }

//       setAttendance(
//         students.map((s) => ({
//           id: s._id,
//           name: s.name,
//           placementPriority: s.placementPriority || 'Medium',
//           ready: s.readyToPlace || false,
//         }))
//       );
//     } catch {
//       toast.error('Failed to fetch students');
//     }
//   };

//   /* ================= STEP HANDLERS ================= */
//   const handleNext = async () => {
//     if (disable) return;
//     setLoading(true);
//     await getStudents();
//     setCurrentStep(2);
//     setLoading(false);
//   };

//   const handleBack = () => {
//     setCurrentStep(1);
//     clearAttendance();
//     setDisable(true);
//   };

//   /* ================= MODAL ================= */
//   const confirmPlacementReady = (student) => {
//     setSelectedStudent(student);
//     setIsModalOpen(true);
//   };

//   const handleSubmit = async () => {
//     if (!selectedStudent) return;

//     try {
//       const payload = {
//         studentId: selectedStudent.id,
//         placementPriority: selectedStudent.placementPriority,
//         courseId: classData.courseId,
//         batchId: classData.batchId,
//         selectedBranch,
//       };

//       const res = await studentService.makeReadyForPlacement(payload);
//       toast.success(res?.data?.message);

//       setAttendance((prev) =>
//         prev.map((s) =>
//           s.id === selectedStudent.id ? { ...s, ready: true } : s
//         )
//       );

//       setIsModalOpen(false);
//     } catch {
//       toast.error('Failed to mark ready');
//     }
//   };

//   /* ================= STEP RENDER ================= */
//   const displayStep = () => {
//     if (currentStep === 1) {
//       return (
//         <SelectClass
//           classData={classData}
//           setClassData={setClassData}
//           courses={courses}
//           loadingCourses={loadingCourses}
//           batchStructures={batchStructures}
//           fetchBatchStructures={fetchBatchStructures}
//           fetchBatchesByStructure={fetchBatchesByStructure}
//           setDisable={setDisable}
//           clearAttendance={clearAttendance}
//           loading={loading}
//         />
//       );
//     }

//     return (
//       <AttendancesSheet
//         attendance={attendance}
//         setAttendance={setAttendance}
//         confirmPlacementReady={confirmPlacementReady}
//       />
//     );
//   };

//   return (
//     <div className="mt-10 h-full w-full">
//       <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600" />

//       <div className="mx-auto h-full w-5/6 md:px-3 3xl:w-7/12">
//         <Card extra="-mt-[280px] w-full md:-mt-[340px] md:px-[70px] pb-3">
//           <UseContextProvider>{displayStep()}</UseContextProvider>

//           <div className="flex justify-end px-3 pt-4">
//             {currentStep === 2 && (
//               <button
//                 onClick={handleBack}
//                 className="mr-3 rounded-xl bg-gray-200 px-14 py-2"
//               >
//                 Prev
//               </button>
//             )}

//             {currentStep === 1 && (
//               <button
//                 disabled={disable}
//                 onClick={handleNext}
//                 className="rounded-xl bg-brand-900 px-16 py-2 text-white disabled:opacity-60"
//               >
//                 {loading ? 'Loading...' : 'Next'}
//               </button>
//             )}
//           </div>
//         </Card>
//       </div>

//       <ConfirmationModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         onConfirm={handleSubmit}
//         title="Confirm Placement Readiness"
//         message={`Mark ${selectedStudent?.name} as ready for placement?`}
//         confirmText="Yes"
//         cancelText="Cancel"
//       />
//     </div>
//   );
// };

// export default MarkAttendance;
import courseService from 'ApiService/Admin/courseService';
import studentService from 'ApiService/Admin/studentService';
import batchService from 'ApiService/Admin/batchService';

import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';

import SelectClass from './Class/Index';
import AttendancesSheet from './Sheet/Index';
import ConfirmationModal from 'pages/Common/ConfirmationModal';
import PlacementReadySearch from 'pages/Common/PlacementReadySearch';

const MarkAttendance = () => {
  /* ================= STEP ================= */
  const [currentStep, setCurrentStep] = useState(1);

  /* ================= CLASS DATA ================= */
  const [classData, setClassData] = useState({
    courseId: '',
    batchStructureId: '',
    batchId: '',
  });

  /* ================= DATA ================= */
  const [courses, setCourses] = useState([]);
  const [batchStructures, setBatchStructures] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [searchResults, setSearchResults] = useState([]);

  /* ================= UI ================= */
  const [disable, setDisable] = useState(true);
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [loadingStudents, setLoadingStudents] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  /* ================= AUTH ================= */
  const { state, loading } = useContext(AuthContext);

  const user = state?.user;
  const role = user?.role;
  const isSuperAdmin = role === 'superadmin';

  const selectedBranch = isSuperAdmin
    ? state?.selectedBranch
    : user?.branch?._id;

  /* ================= RESET ================= */
  const resetPage = () => {
    setClassData({
      courseId: '',
      batchStructureId: '',
      batchId: '',
    });
    setBatchStructures([]);
    setAttendance([]);
    setDisable(true);
    setCurrentStep(1);
  };

  /* ================= RESET ON BRANCH CHANGE ================= */
  useEffect(() => {
    if (!isSuperAdmin) return;
    if (!selectedBranch) return;
    resetPage();
  }, [selectedBranch, isSuperAdmin]);

  /* ================= FETCH COURSES ================= */
  const fetchCourses = async () => {
    try {
      setLoadingCourses(true);
      const res = await courseService.getAllCourses(selectedBranch);
      setCourses(res?.data?.courses || []);
    } catch {
      toast.error('Failed to fetch courses');
      setCourses([]);
    } finally {
      setLoadingCourses(false);
    }
  };

  /* ================= SAFE FETCH COURSES ================= */
  useEffect(() => {
    if (loading) return;
    if (!user) return;
    if (isSuperAdmin && !selectedBranch) return;

    fetchCourses();
  }, [loading, user, isSuperAdmin, selectedBranch]);

  /* ================= FETCH STRUCTURES ================= */
  const fetchBatchStructures = async (courseId) => {
    try {
      const res = await batchService.getBatchStructuresByCourse(
        courseId,
        selectedBranch
      );
      setBatchStructures(res?.data?.batchStructures || []);
    } catch {
      toast.error('Failed to fetch batch structures');
      setBatchStructures([]);
    }
  };

  /* ================= FETCH BATCHES ================= */
  const fetchBatchesByStructure = async (structureId) => {
    try {
      const res = await batchService.getBatchesByBatchStructure(
        structureId,
        selectedBranch
      );
      return res?.data?.batches || [];
    } catch {
      toast.error('Failed to fetch batches');
      return [];
    }
  };

  /* ================= FETCH STUDENTS ================= */
  const fetchStudents = async () => {
    try {
      setLoadingStudents(true);

      const res = await studentService.getAllStudentforPlacement(
        classData.courseId,
        classData.batchId,
        selectedBranch
      );

      const students = res?.data?.data || [];

      if (!students.length) {
        toast.info('No students found');
        setAttendance([]);
        return;
      }

      setAttendance(
        students.map((s) => ({
          id: s._id,
          name: s.name,
          placementPriority: s.placementPriority || 'Medium',
          ready: s.readyToPlace || false,
        }))
      );
    } catch {
      toast.error('Failed to fetch students');
    } finally {
      setLoadingStudents(false);
    }
  };

  /* ================= STEP HANDLERS ================= */
  const handleNext = async () => {
    if (disable) return;
    await fetchStudents();
    setCurrentStep(2);
  };

  const handleBack = () => {
    setCurrentStep(1);
    setAttendance([]);
  };

  /* ================= MODAL ================= */
  const confirmPlacementReady = (student) => {
    setSelectedStudent(student);
    setIsModalOpen(true);
  };

  const handleSubmit = async () => {
    if (!selectedStudent) return;

    try {
      const payload = {
        studentId: selectedStudent.id,
        placementPriority: selectedStudent.placementPriority,
        courseId: selectedStudent.courseId || classData.courseId,
        batchId: selectedStudent.batchId || classData.batchId,
        selectedBranch: selectedStudent.branchId || selectedBranch,
      };

      const res = await studentService.makeReadyForPlacement(payload);
      toast.success(res?.data?.message);

      setAttendance((prev) =>
        prev.map((s) =>
          s.id === selectedStudent.id ? { ...s, ready: true } : s
        )
      );
      setSearchResults((prev) =>
        prev.map((s) =>
          s.id === selectedStudent.id ? { ...s, ready: true } : s
        )
      );

      setIsModalOpen(false);
    } catch {
      toast.error('Failed to mark ready');
    }
  };

  /* ================= LOADERS ================= */
  if (loading) {
    return (
      <div className="flex h-60 items-center justify-center">
        Loading user...
      </div>
    );
  }

  /* ================= STEP RENDER ================= */
  const displayStep = () => {
    if (currentStep === 1) {
      return (
        <>
          {/* Universal search: no branch sent, so superadmin searches every
              branch and admins are limited to their own by the middleware */}
          <PlacementReadySearch
            searchStudents={(term) =>
              studentService.searchStudentsForPlacement(term)
            }
            results={searchResults}
            setResults={setSearchResults}
            confirmPlacementReady={confirmPlacementReady}
          />
          {isSuperAdmin && !selectedBranch ? (
            <div className="flex h-40 items-center justify-center text-gray-500">
              Please select a branch to choose a course &amp; batch
            </div>
          ) : (
            <SelectClass
              classData={classData}
              setClassData={setClassData}
              courses={courses}
              loadingCourses={loadingCourses}
              batchStructures={batchStructures}
              fetchBatchStructures={fetchBatchStructures}
              fetchBatchesByStructure={fetchBatchesByStructure}
              setDisable={setDisable}
              clearAttendance={() => setAttendance([])}
            />
          )}
        </>
      );
    }

    return (
      <AttendancesSheet
        attendance={attendance}
        setAttendance={setAttendance}
        confirmPlacementReady={confirmPlacementReady}
        loading={loadingStudents}
      />
    );
  };

  return (
    <div className="mt-10 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600" />

      <div className="mx-auto h-full w-5/6 md:px-3 3xl:w-7/12">
        <Card extra="-mt-[280px] w-full md:-mt-[340px] md:px-[70px] pb-3">
          <UseContextProvider>{displayStep()}</UseContextProvider>

          <div className="flex justify-end px-3 pt-4">
            {currentStep === 2 && (
              <button
                onClick={handleBack}
                className="mr-3 rounded-xl bg-gray-200 px-14 py-2"
              >
                Prev
              </button>
            )}

            {currentStep === 1 && (
              <button
                disabled={disable}
                onClick={handleNext}
                className="rounded-xl bg-brand-900 px-16 py-2 text-white disabled:opacity-60"
              >
                Next
              </button>
            )}
          </div>
        </Card>
      </div>

      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleSubmit}
        title="Confirm Placement Readiness"
        message={`Mark ${selectedStudent?.name} as ready for placement?`}
        confirmText="Yes"
        cancelText="Cancel"
      />
    </div>
  );
};

export default MarkAttendance;
